import styled from 'styled-components';


export const StyledChart = styled.div`

`;
